export class ListAzureSKUs200ResponseSkusInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "tier",
            "baseName": "tier",
            "type": "string",
            "format": "tobedefined"
        },
        {
            "name": "capabilities",
            "baseName": "capabilities",
            "type": "{ [key: string]: string; }",
            "format": "tobedefined"
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureSKUs200ResponseSkusInner.attributeTypeMap;
    }
    constructor() {
    }
}
